export const APP_NAME = import.meta.env.VITE_APP_APP_NAME || "The Older One";
export const IS_MULTIPLAYER_TEMPORARILY_DISABLED = false;

export const getPageTitle = (title?: string) =>
	title ? `${title} | ${APP_NAME}` : APP_NAME;
